module.exports = __webpack_public_path__ + "img/pro-1.7e42c4e4.webp";